import { useEffect, useState } from "react";

const useRecorder = () => {
	const [audioData, setAudioData] = useState([]);
	const [audioURL, setAudioURL] = useState("");
	const [isRecording, setIsRecording] = useState(false);
	const [recorder, setRecorder] = useState(null);
	const [end, setEnd] = useState(false);

	useEffect(() => {
		if (recorder === null) {
			if (isRecording) {
				requestRecorder().then(setRecorder, console.error);
			}
			return;
		}
		if (isRecording) {
			recorder.start();
		} else {
			recorder.stop();
		}
		const handleData = (e) => {
			// console.log(e.data);
			setAudioData((prev) => [...prev, e.data]);
		};
		const handleStop = (e) => {
			setEnd(true);
		};

		recorder.addEventListener("dataavailable", handleData);
		recorder.addEventListener("stop", handleStop);
		return () => {
			recorder.removeEventListener("dataavailable", handleData);
		};

		// eslint-disable-next-line
	}, [recorder, isRecording]);
	const startRecording = () => {
		setIsRecording(true);
	};
	const stopRecording = () => {
		setIsRecording(false);
		// console.log({ audioData, audioURL });
	};
	const resetRecorder = () => {
		setAudioData([]);
		setAudioURL("");
	};

	useEffect(() => {
		if (end) {
			var blob = new Blob(audioData, { type: "audio/ogg; codecs=opus" });
			setAudioURL(URL.createObjectURL(blob));
		}
	}, [audioData, end]);

	return [audioURL, isRecording, startRecording, stopRecording, resetRecorder];
};

async function requestRecorder() {
	const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
	return new MediaRecorder(stream);
}

export default useRecorder;
